import { makeRequest } from '../../../lib/api';

const AUTH_PATH = '/v1/users/auth';
const USER_PATH = '/v1/users';
const NOTIFICATION_PATH = '/v1/notifications';

class authController {
  /* login = (data = {}) => {
    return makeRequest('post', `${ AUTH_PATH }?username=${ data.username }&password=${ data.password }`);
  }; */

  login = (data = {}) => {
    const formData = new FormData();
    formData.append('username', data.username);
    formData.append('password', data.password);
    return makeRequest('post', `${ AUTH_PATH }`, formData);
  };

  getProfile = (data = {}) => {
    return makeRequest('get', `${ USER_PATH }/profile`, data);
  };

  getNotificationsWsnt = (deviceId) => {
    return makeRequest('get', `${ NOTIFICATION_PATH }/wsnt?deviceId=${ deviceId }`);
  };

  completeRegistration = (data = {}) => {
    return makeRequest('post', `${ USER_PATH }/confirm/${ data.code }?${ data.url }`, data);
  };

  getRegistrationInfo = (data = {}) => {
    return makeRequest('get', `${ USER_PATH }/invite/${ data.code }?${ data.url }`, data);
  };

  /* запросить сброс пароля (выслать ссылку) */
  restorePasswordStart = (data = {}) => {
    return makeRequest('post', `${ USER_PATH }/password/restore`, data, { skipAuth: true });
  };

  /* сбросить пароль */
  restorePasswordEnd = (data = {}) => {
    return makeRequest('put', `${ USER_PATH }/password/restore/confirm/${ data.code }`, data, { skipAuth: true });
  };
}

export default new authController();
